import { Component } from 'react';
import PropTypes from 'prop-types';

class SlideshowHeroControl extends Component {
  constructor(props) {
    super(props);
    this.handleSlideTransition = this.handleSlideTransition.bind(this);
  }

  handleSlideTransition(e) {
    const { goToSlide, selectedIndex, slideshowId } = this.props;
    const { slide, id } = e.detail;
    if (id === slideshowId && slide !== selectedIndex) {
      goToSlide(slide);
    }
  }

  componentDidMount() {
    window.addEventListener('slideshowTransition', this.handleSlideTransition);
  }

  componentWillUnmount() {
    window.removeEventListener('slideshowTransition', this.handleSlideTransition);
  }

  render() {
    return null;
  }
}

SlideshowHeroControl.propTypes = {
  goToSlide: PropTypes.func,
  slideshowId: PropTypes.string,
  selectedIndex: PropTypes.number
};

export default SlideshowHeroControl;
